// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { systemlink16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-systemlink': IconSystemlink;
    }
}

/**
 * The icon component for the 'systemlink' icon
 */
export class IconSystemlink extends Icon {
    public constructor() {
        super(systemlink16X16);
    }
}

registerIcon('icon-systemlink', IconSystemlink);
export const iconSystemlinkTag = 'nimble-icon-systemlink';
